import React, { useState, useEffect } from 'react';

// Utility functions
const getDayAbbreviation = (day) => {
    const dayMap = {
      Monday: 'Mon',
      Tuesday: 'Tue',
      Wednesday: 'Wed',
      Thursday: 'Thu',
      Friday: 'Fri',
      Saturday: 'Sat',
      Sunday: 'Sun',
    };
    return dayMap[day];
  };
  
  const getDayOrder = (day) => {
    const order = {
      Monday: 1,
      Tuesday: 2,
      Wednesday: 3,
      Thursday: 4,
      Friday: 5,
      Saturday: 6,
      Sunday: 7,
    };
    return order[day];
  };
  
  const convertTo24Hr = (timeStr) => {
    const [time, modifier] = timeStr.split(" ");
    let [hours, minutes] = time.split(":");
    if (hours === "12") hours = "00";
    if (modifier === "PM") hours = parseInt(hours, 10) + 12;
    return `${hours.toString().padStart(2, "0")}:${minutes}`;
  };
  
  const formatScheduleSummary = (timeslots) => {
    const uniqueDays = [...new Set(timeslots.map(slot => slot.DayOfWeek))];
    const sortedDays = uniqueDays.sort((a, b) => getDayOrder(a) - getDayOrder(b));
  
    const dayAbbreviations = sortedDays.map(getDayAbbreviation);
    const dayRangeText = dayAbbreviations.length > 1
      ? `${dayAbbreviations[0]} - ${dayAbbreviations[dayAbbreviations.length - 1]}`
      : dayAbbreviations[0];
  
    const parseTime = (t) => new Date(`1970-01-01T${convertTo24Hr(t)}:00`);
    const startTimes = timeslots.map(t => parseTime(t.StartTime));
    const endTimes = timeslots.map(t => parseTime(t.EndTime));
  
    const minStart = new Date(Math.min(...startTimes));
    const maxEnd = new Date(Math.max(...endTimes));
  
    const formatTime = (d) =>
      d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
  
    const timeRangeText = `${formatTime(minStart)} - ${formatTime(maxEnd)}`;
  
    return {
      dayRange: dayRangeText,
      timeRange: timeRangeText,
    };
  };
  

const InstituteTrainingFreeHoursPopup = ({setShowInstituteTrainingFreeHoursPopup, timeSlots}) => {
    const handleCancelPopupClick = () =>{
        setShowInstituteTrainingFreeHoursPopup(false)
      }
    
    const [scheduleSummary, setScheduleSummary] = useState({
    dayRange: '',
    timeRange: ''
    });

    useEffect(() => {
    if (timeSlots && timeSlots.length > 0) {
        const result = formatScheduleSummary(timeSlots);
        setScheduleSummary(result);
    }
    }, [timeSlots]);
  
  return (
        <div className="relative rounded-[9px] bg-[linear-gradient(270deg,_#D7D9FF_0%,_#FFFFFF_100%)] px-[30px] pb-[20px] pt-[20px] shadow-lg w-[300px]"> 
            <div className="absolute top-2 right-2">
              <img
                className="absolute right-1 top-[4px] cursor-pointer"
                src={require("../Assets/Cross.svg").default}
                alt=""
                onClick={handleCancelPopupClick}
              />
            </div>

            <div className="flex flex-col gap-[15px]">
                <p className="text-[16px] text-center font-bold">Institute Training Hours</p>

                <div className="flex justify-between ">
                    <p className="text-[16px] text-[#000000] font-semibold">Days</p>
                    <p className="text-[16px] text-[#000000]">{scheduleSummary?.dayRange}</p>
                </div>

                <div className="flex justify-between ">
                    <p className="text-[16px] text-[#000000] font-semibold">Time</p>
                    <p className="text-[16px] text-[#000000]">{scheduleSummary?.timeRange}</p>
                </div>
            </div>
          
        </div>
  );
};

export default InstituteTrainingFreeHoursPopup;

